<template>
  <div class="alert" v-if="true">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-alert
            icon="mdi-exclamation-thick"
            prominent
            text
            type="info"
            color="red"
          >
            Обращаем Ваше внимание, что для направления заявления о совершении
            нотариального действия в удаленном формате Вам потребуется ключ УКЭП
            (усиленной квалифицированной электронной подписи). О том, как его
            получить, Вы можете узнать здесь:
            <a
              href="https://digital.gov.ru/ru/activity/govservices/2/"
              target="_blank"
              >https://digital.gov.ru</a
            >
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Alert',
};
</script>

<style scoped lang="scss">
.alert {
  margin-bottom: 15px;

  &::v-deep .v-alert__content,
  a {
    font-size: 12px;
  }

  &::v-deep .v-alert--prominent .v-alert__icon:after {
    top: 7px;
    width: 30px;
    height: 30px;
    left: 8px;
  }

  &::v-deep .v-alert--prominent .v-alert__icon:after {
    top: 7px;
    width: 30px;
    height: 30px;
    left: 8px;
  }

  &::v-deep .v-alert--prominent .v-alert__icon.v-icon {
    font-size: 27px;
  }
}
</style>
